/**
 * ============================================================================
 * CALENDAR CACHE MANAGER v2.0
 * ============================================================================
 *
 * Zentrales Cache-Management für den Kalender.
 * Kann von anderen Komponenten importiert werden, ohne zirkuläre Imports.
 *
 * ✅ v2.0: Event-basierte Invalidierung
 *    - Kalender kann auf externe Änderungen reagieren
 *    - subscribeToInvalidation() für Event-Listener
 *
 * @version 2.0.0
 */

// ============================================================================
// GLOBALER STATE
// ============================================================================
let GLOBAL_APPOINTMENTS_CACHE = [];
let GLOBAL_HAS_LOADED = false;
let GLOBAL_LOADING_PROMISE = null;

// ✅ v2.0: Event-Listener für Cache-Invalidierung
let invalidationListeners = [];

// ============================================================================
// EXPORTED FUNCTIONS
// ============================================================================

/**
 * ✅ v2.0: Registriert einen Listener für Cache-Invalidierung
 * @returns {Function} Unsubscribe-Funktion
 */
export const subscribeToInvalidation = (callback) => {
  invalidationListeners.push(callback);
  console.log('📅 Cache invalidation listener added, total:', invalidationListeners.length);

  // Return unsubscribe function
  return () => {
    invalidationListeners = invalidationListeners.filter(cb => cb !== callback);
    console.log('📅 Cache invalidation listener removed, remaining:', invalidationListeners.length);
  };
};

/**
 * Invalidiert den Kalender-Cache
 * Wird aufgerufen, wenn extern ein Termin erstellt wird (z.B. aus Tasks)
 * ✅ v2.0: Benachrichtigt alle Listener
 */
export const invalidateCalendarCache = () => {
  console.log('📅 Calendar cache invalidated, notifying', invalidationListeners.length, 'listeners');
  GLOBAL_HAS_LOADED = false;

  // ✅ v2.0: Alle Listener benachrichtigen
  invalidationListeners.forEach(callback => {
    try {
      callback();
    } catch (err) {
      console.warn('📅 Listener error:', err);
    }
  });
};

/**
 * Setzt den Cache komplett zurück
 */
export const clearCalendarCache = () => {
  console.log('📅 Calendar cache cleared');
  GLOBAL_APPOINTMENTS_CACHE = [];
  GLOBAL_HAS_LOADED = false;
  GLOBAL_LOADING_PROMISE = null;
};

/**
 * Getter für den Cache
 */
export const getCalendarCache = () => GLOBAL_APPOINTMENTS_CACHE;

/**
 * Setter für den Cache
 */
export const setCalendarCache = (appointments) => {
  GLOBAL_APPOINTMENTS_CACHE = appointments;
};

/**
 * Prüft ob Cache geladen wurde
 */
export const isCalendarCacheLoaded = () => GLOBAL_HAS_LOADED;

/**
 * Setzt das Loaded-Flag
 */
export const setCalendarCacheLoaded = (loaded) => {
  GLOBAL_HAS_LOADED = loaded;
};

/**
 * Getter für Loading Promise
 */
export const getLoadingPromise = () => GLOBAL_LOADING_PROMISE;

/**
 * Setter für Loading Promise
 */
export const setLoadingPromise = (promise) => {
  GLOBAL_LOADING_PROMISE = promise;
};

console.log('✅ calendarCache.js loaded');
